module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAEBSURBVDhPY/hPIkDXcPzx466jR5M3bizdtWvllSuff/6ESsAAQsP99++t585lqKxkKCsDkRUVQAZHS8v8c+egKsAAquHyy5eiXV0gRfX1INTQAEJARk0NQ3l5w/79EGVAANLw++9f7alTQaZC1KGh2lqgto03biA09B8/zlBVhTAYE1VVGc+c+eP3b6gGryVLCGioq2NsaLj04gVIA9A9BtOng9yKpggZ1dUBjdtw/TrRGoCW19WtunKFNCddhjgJiPuPHSPN0wSCFeiB6uqNYA9ANQABaREHAViSRnk5T1vbwgsXoCrAAKEBAiCJL2nDhpJdu1ZfvfoFT+IjCvz/DwCQ2eroFHU3BQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/hub-node.png
// module id = 986
// module chunks = 0